export default Object.freeze({
    SKILLINFO_NOTE_MAX_LEN: 256 //備考　最大桁数
  });